import React from 'react';
import ProductImage from 'components/ui/productImage';
import View from 'components/ui/view';
import { QuickViewSummary } from 'components/quickView';
import ProductQtySelector from 'components/product/qtySelector';

export default function SubstitutionProduct({
  product,
  defaultQty,
  chooseSubstitution
}) {
  if (!product) return null;

  return (
    <View margin="md" className="substitutions-detail__product-container">
      <div className="row">
        <div className="col-xs-12 col-sm-5 text-center">
          <ProductImage
            large
            product={product}
            className="substitutions-detail__product-img"
            alt={product.title}
          />
        </div>
        <div className="col-xs-12 col-sm-7">
          <View padding={{ sides: 'sm' }} margin="md">
            <QuickViewSummary product={product} />

            <div className="row">
              <div className="col-xs-12 col-sm-10 col-md-9">
                <ProductQtySelector
                  defaultQty={defaultQty}
                  buttonText="Substitute"
                  buttonAction={chooseSubstitution}
                />
              </div>
            </div>
          </View>
        </div>
      </div>
    </View>
  );
}



// WEBPACK FOOTER //
// ./shared/components/substitutions/product.js